import { messagesEN } from '../locales/messages_EN';
import { messagesIrl } from '../locales/messages_IRL';
const JA_LOCALIZATION_IRL = JSON.parse(process.env.VUE_APP_JA_LOCALIZATION_IRL);
const currencySymbol =
	JA_LOCALIZATION_IRL == true
		? messagesIrl.currencySymbol
		: messagesEN.currencySymbol;

export default {
	filters: {
		currency: function(value) {
			let isNegative = false;
			if (value < 0) {
				isNegative = true;
			}
			let numberWithComma = Math.abs(value)
				.toFixed(0)
				.toString()
				.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

			return `${isNegative ? '-' : ''}${currencySymbol}${numberWithComma}`;
		},
		dateFormat: function(dateTime) {
			const currentLanguage = sessionStorage.getItem('currentLanguage');
			var date = new Date(dateTime);
			var options = { month: 'short', day: 'numeric', year: 'numeric' };
			return date.toLocaleDateString(currentLanguage, options);
		},
		dateFormatNumeric: function(dateTime) {
			var date = new Date(dateTime);
			var options = { day: '2-digit', month: '2-digit', year: 'numeric' };
			return date
				.toLocaleDateString('en-US', options)
				.split('/')
				.join('-');
		},
		timeFormat: function(dateTime) {
			var time = new Date(dateTime);
			var options = { hour: '2-digit', minute: '2-digit' };
			return time.toLocaleTimeString('en-US', options);
		},
		reverse: function(facilities) {
			return facilities.slice().reverse();
		}
	},
	create: function(Vue) {
		var filters = Object.keys(this.filters);
		filters.forEach(filter => {
			Vue.filter(filter, this.filters[filter]);
		});
	}
};
